module.exports = __webpack_public_path__ + "img/default-dude.ce88b1c9.svg";